import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
const firebaseConfig = {
  apiKey: "AIzaSyBbcPajWLTkbBdkCwQxJrWFciQzkCooPl4",
  authDomain: "image-9bcce.firebaseapp.com",
  projectId: "image-9bcce",
  storageBucket: "image-9bcce.appspot.com",
  messagingSenderId: "239174208053",
  appId: "1:239174208053:web:f0ac59cac997c26b393f7c",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
